export enum GroupEnums {
  get = 'PcbGroup/Groups', // 取得機台自訂分類清單
  reArrange = 'PcbGroup/Rearrange', // 重新分類機台群組
  add = 'PcbGroup/Add', // 新增機台自訂分類
  update = 'PcbGroup/Update', // 編輯機台自訂分類
  delete = 'PcbGroup/Delete' // 刪除機台自訂分類
}
